export const MAX_ITEMS_PER_ROW = 3;
export const MIN_ITEM_SPAN = 4;

export const TOTAL_NUMBER_OF_COLUMNS = 12;

export const ITEM_GAP = 16;
export const ROW_GAP = 16;

export const INDICATOR_SIZE = 2;
export const HANDLE_SIZE = 16;

export const ROW_ID_PREFIX = 'dnd-row';

export const HORIZONTAL_INDICATOR_ABOVE_ID_PREFIX =
	'dnd-horizontal-indicator-above';
export const HORIZONTAL_INDICATOR_BELOW_ID_PREFIX =
	'dnd-horizontal-indicator-below';

export const VERTICAL_INDICATOR_BEFORE_ID_PREFIX =
	'dnd-vertical-indicator-before';
export const VERTICAL_INDICATOR_AFTER_ID_PREFIX =
	'dnd-vertical-indicator-after';
